import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import React from 'react';
import Typography from '@mui/material/Typography';
import styled from '@mui/styles/styled';
import { renderablePropType } from '../../../../utils/propTypes';

const StyledDivider = styled(Divider)({
	flex: 1,
});

const Text = styled('span')(({ theme }) => ({
	padding: `0 ${theme.spacing()}px`,
	textTransform: 'uppercase',
}));
function DividerText({ children, ...props }) {
	return (
		<Grid container alignItems="center" wrap="nowrap" {...props}>
			<StyledDivider />
			<Typography variant="caption">
				<Text>{children}</Text>
			</Typography>
			<StyledDivider />
		</Grid>
	);
}

DividerText.propTypes = {
	children: renderablePropType,
};

export default DividerText;
